import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import logo from '../../assets/vbc-logo.png'; // Updated logo for KVP Trade LTD
import './SplashScreen.css';

const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  // Logo animation variants
  const logoVariants = {
    hidden: { opacity: 0, scale: 0.8, rotateX: 45 },
    visible: {
      opacity: 1,
      scale: [1, 1.05, 1], // Pulsating effect
      rotateX: 0,
      transition: {
        duration: 2,
        ease: 'easeOut',
        scale: { duration: 1.5, repeat: Infinity, repeatType: 'reverse' },
      },
    },
  };

  // Headline animation variants
  const headlineTopVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, delay: 0.5, ease: 'easeOut' },
    },
  };

  const headlineBottomVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, delay: 0.8, ease: 'easeOut' },
    },
  };

  return (
    <motion.div
      className={`splash-screen ${isVisible ? 'visible' : 'hidden'}`}
      initial={{ opacity: 1 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={{ duration: 1.2 }}
    >
      <motion.img
        src={logo}
        alt="KVP Trade LTD Logo"
        className="splash-logo"
        variants={logoVariants}
        initial="hidden"
        animate="visible"
      />
      <div className="splash-headline">
        <motion.h1
          className="splash-headline-top"
          variants={headlineTopVariants}
          initial="hidden"
          animate="visible"
        >
          Bulk Unleashed
        </motion.h1>
        <motion.p
          className="splash-headline-bottom"
          variants={headlineBottomVariants}
          initial="hidden"
          animate="visible"
        >
          London’s Cash & Carry Powerhouse
        </motion.p>
      </div>
      <div className="splash-loader">
        <motion.div
          className="loader-bar"
          initial={{ width: 0 }}
          animate={{ width: '100%' }}
          transition={{ duration: 4, ease: 'easeInOut' }}
        />
      </div>
    </motion.div>
  );
};

export default SplashScreen;